<template>
  <div class="modal"
       :class="{'is-active': active, 'is-modal-xlarge is-modal-fullHeight': device == 'desktop'}"
       v-if="d || url || link || urlContrat || linkEmbed"
  >
    <div class="modal-background" @click.prevent.stop="close"></div>
    <div class="modal-card">
      <div class="row-width-actions-bar">
        <div class="columns is-gapless is-vcentered is-border-bottom">
          <div class="column is-padding-left">
            <div class="has-text-dark is-size-6 is-uppercase">
              <span class="has-text-weight-medium">Aperçu document</span>
            </div>
          </div>
          <div class="column is-narrow is-border-left">
            <a class="page-header-btn is-small is-square" @click="close">
              <span class="icon is-size-4 has-text-dark"><i class="fal fa-times"></i></span>
            </a>
          </div>
        </div>
      </div>
      <section class="modal-card-body">
        <spinner-round :isLoading="loading" v-if="!errorMessage"></spinner-round>
        <form class="columns is-gapless is-column is-min-height-full">
          <div class="column"
               v-if="device === 'desktop'"
          >
            <!-- <object
              :data="embedPath"
              type="application/pdf"
              width="100%"
              height="100%"> -->
            <iframe
                    v-if="urlContrat || link"
                    @load='loading = false'
                    :src="embedPath"
                    width="100%"
                    height="100%"
                    style="border: none;min-height: calc(-50px + 100vh);">
              <p>Your browser does not support PDFs.
                <a :href="embedPath">Download the PDF</a>.</p>
            </iframe>
            <embed v-else
                   :src="embedPath"
                   width="100%"
                   height="100%"
                   style="border: none; min-height: calc(100vh - 150px)"
                   type="application/pdf"><!-- HB : minHeight obligé pour safari (desktop et tablette) -->
            <!-- </object> -->
            <!-- <iframe :src="embedPath" width="100%" height="400px" @load="loading = false" v-if="embedPath && !errorMessage"></iframe>
            <strong v-if="errorMessage">Erreur lors de l'ouverture du document, veuillez essayer plus tard.</strong> -->
          </div>
          <div class="column is-narrow columns" v-if="urlContrat">
            <div class="column">
              <button @click="close()" class="button">fermer</button>
            </div>
          </div>
          <div class="column is-narrow columns" v-else-if="d">
            <div class="column">
              <button @click="download(d.path)" class="button">Télécharger</button>
            </div>
          </div>
          <div class="column is-narrow columns is-gapless is-centered has-bg-white is-padding-top-small is-padding-bottom-small"
               v-else-if="link === undefined">
            <div class="column"
                 :class="[device == 'desktop' ? 'is-4' : 'is-5']"
            >
              <button @click="close()" class="button is-transform-none is-light is-full">
                <span>Annuler</span>
              </button>
            </div>
            <div v-if="linkEmbed && facture"
                 class="column is-margin-left-small"
                 :class="[device == 'desktop' ? 'is-4' : 'is-5']"
            >
              <button @click="download(embedPath)" type="button" class="button is-transform-none is-success is-full">
                <span>Télécharger Facture</span>
                <span class="icon">
                      <i class="fas fa-download"></i>
                  </span>
              </button>
            </div>
            <div v-else-if="linkEmbed"
                 class="column is-margin-left-small"
                 :class="[device == 'desktop' ? 'is-4' : 'is-5']"
            >
              <button @click="download(embedPath)" type="button" class="button is-transform-none is-success is-full">
                <span>Télécharger LRE</span>
                <span class="icon">
                      <i class="fas fa-download"></i>
                  </span>
              </button>
            </div>
            <div v-else
                 class="column is-margin-left-small"
                 :class="[device == 'desktop' ? 'is-4' : 'is-5']"
            >
              <button @click="download(url)" type="button" class="button is-transform-none is-success is-full">
                <span>Télécharger courrier SRU</span>
                <span class="icon">
                      <i class="fas fa-download"></i>
                  </span>
              </button>
            </div>
          </div>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'DocumentModalPreview',
    data () {
      return {
        loading: true,
        errorCount: 0,
        interval: null,
        errorMessage: false
      }
    },
    props: {
      active: {
        type: Boolean,
        required: true
      },
      selectedDocument: {
        type: Object
      },
      link: String,
      linkEmbed: String,
      idBuyer: {
        type: String
      },
      idAdv: {
        type: String
      },
      youSign: {
        type: String
      },
      facture: {
        default: false,
        type: Boolean
      }
    },
    computed: {
      ...mapState(['device']),
      d () {
        if (!this.selectedDocument) return
        return this.selectedDocument
      },
      url () {
        if (!this.idAdv && !this.idBuyer) return
        const apiUrl = this.$configs.APIROOT
        return apiUrl + '/pdf/sru/' + this.idAdv + '/buyer/' + this.idBuyer
      },
      urlContrat () {
        if (!this.youSign) return
        const apiUrl = this.$configs.APIROOT
        return apiUrl + this.youSign
      },
      embedPath () {
        if (this.d && this.d.path) {
          return this.d.path
        } else if (this.link) {
          return this.link
        } else if (this.linkEmbed) {
          return this.linkEmbed
        } else if (this.url) {
          return this.url
        } else if (this.urlContrat) {
          return this.urlContrat
        }
      }
    },
    methods: {
      close () {
        this.$emit('close')
      },
      reloadIframe () {
        this.errorCount++
        // clearInterval(this.interval)
        if (!this.loading) clearInterval(this.interval)
        if (this.errorCount > 3) {
          this.errorMessage = true
          clearInterval(this.interval)
        }
      },
      download (file) {
        let link = document.createElement('a')
        link.href = file
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
      }
    },
    created () {
      if (this.urlContrat) {
        this.loading = true
      }
      if (!this.urlContrat || !this.link) {
        this.interval = setInterval(() => {
          this.loading = false
        }, 3000)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/utils/DocumentModalPreview.vue